/**
 * @generated SignedSource<<92339571abd12889b7fe9f623fe3efb0>>
 * @relayHash 1734012ec70297f0d19082fcb8825f09
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/571.0.0-2026-08-04T16:01:33.074Z/PdpRespUnavailableLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableLayoutRefetchQuery$variables = {
  afterDisplay: boolean;
  afterDisplayAndBtNone: boolean;
  afterDisplayOrBtSsr: boolean;
  fetchChat: boolean;
  fetchUser: boolean;
  guestId?: string | null;
  isPdpSimilarSoldItemsModuleVariant: boolean;
  isTrade: boolean;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  maxSponsoredItems?: number | null;
  minSponsoredItemsSteps?: ReadonlyArray<number> | null;
  numOfSponsoredItems?: number | null;
  priceBookName?: string | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type PdpRespUnavailableLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableLayout_viewer">;
  };
};
export type PdpRespUnavailableLayoutRefetchQuery = {
  response: PdpRespUnavailableLayoutRefetchQuery$data;
  variables: PdpRespUnavailableLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplay"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplayAndBtNone"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplayOrBtSsr"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchChat"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guestId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPdpSimilarSoldItemsModuleVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isTrade"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "maxSponsoredItems"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "minSponsoredItemsSteps"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "numOfSponsoredItems"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "priceBookName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userCountryCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userZipCode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "photoType",
    "value": "DEALER_STOREFRONT_HEADSHOT"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v8 = [
  (v6/*:: as any*/),
  (v7/*:: as any*/),
  (v4/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v13 = [
  (v3/*:: as any*/),
  (v4/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "StorefrontProfile",
  "kind": "LinkedField",
  "name": "liveStorefrontProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": (v5/*:: as any*/),
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": (v8/*:: as any*/),
      "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
    }
  ],
  "storageKey": null
},
v15 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v16 = [
  (v15/*:: as any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v27 = [
  (v7/*:: as any*/),
  (v26/*:: as any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v33 = [
  (v31/*:: as any*/),
  (v32/*:: as any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v33/*:: as any*/),
  "storageKey": null
},
v35 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v12/*:: as any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showMakeOffer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v39 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v40 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v44 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v45 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v49 = [
  (v12/*:: as any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v13/*:: as any*/),
  "storageKey": null
},
v51 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v52 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v53 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v54 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v55 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v56 = [
  (v51/*:: as any*/),
  {
    "kind": "Literal",
    "name": "canShowOnHoldForDifferentBuyer",
    "value": false
  },
  (v52/*:: as any*/),
  (v53/*:: as any*/),
  (v54/*:: as any*/),
  (v55/*:: as any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantityDisplay",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentageOff",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPriceLabel",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v63 = [
  (v32/*:: as any*/),
  (v31/*:: as any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v63/*:: as any*/),
  "storageKey": null
},
v65 = [
  (v32/*:: as any*/),
  (v64/*:: as any*/)
],
v66 = [
  (v51/*:: as any*/)
],
v67 = {
  "alias": null,
  "args": (v66/*:: as any*/),
  "kind": "ScalarField",
  "name": "hasRequestedHoldForBuyer",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": [
    (v51/*:: as any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "pdp"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v69 = [
  (v67/*:: as any*/),
  (v68/*:: as any*/)
],
v70 = [
  (v24/*:: as any*/),
  (v4/*:: as any*/)
],
v71 = {
  "alias": "photoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"master\")"
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurementUnit",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurementsList",
      "plural": true,
      "selections": [
        (v73/*:: as any*/),
        (v42/*:: as any*/),
        (v41/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diameter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v75 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v76 = [
  (v75/*:: as any*/),
  (v15/*:: as any*/)
],
v77 = {
  "kind": "Literal",
  "name": "useML",
  "value": true
},
v78 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  (v75/*:: as any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "INCLUDE"
  },
  (v77/*:: as any*/)
],
v79 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v80 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v48/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v35/*:: as any*/),
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": (v49/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v11/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v27/*:: as any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                (v11/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                (v4/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": [
    (v53/*:: as any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v54/*:: as any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v64/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v63/*:: as any*/),
      "storageKey": null
    },
    (v57/*:: as any*/),
    (v58/*:: as any*/),
    (v59/*:: as any*/),
    (v60/*:: as any*/),
    (v61/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v4/*:: as any*/)
          ],
          "storageKey": null
        },
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        (v37/*:: as any*/),
        (v25/*:: as any*/),
        {
          "alias": "mobileText",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE"
            }
          ],
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v11/*:: as any*/),
        (v83/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v91/*:: as any*/),
    (v92/*:: as any*/)
  ],
  "storageKey": null
},
v94 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v95 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": ""
  },
  (v94/*:: as any*/),
  (v75/*:: as any*/),
  {
    "kind": "Literal",
    "name": "maxMLItems",
    "value": 40
  },
  {
    "kind": "Literal",
    "name": "seller",
    "value": "EXCLUDE"
  },
  (v77/*:: as any*/)
],
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewListing",
  "storageKey": null
},
v97 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  },
  (v4/*:: as any*/)
],
v98 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  (v75/*:: as any*/),
  {
    "kind": "Literal",
    "name": "requestSourceRole",
    "value": "BUYER"
  }
],
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v100 = [
  (v64/*:: as any*/)
],
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v102 = [
  (v51/*:: as any*/),
  (v94/*:: as any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpRespUnavailableLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespUnavailableLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PdpRespUnavailableLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTimeAway",
                        "kind": "LinkedField",
                        "name": "activeTimeAway",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "kind": "LinkedField",
                        "name": "liveStorefrontProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aboutUsUnbranded",
                            "storageKey": null
                          },
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "establishmentYear",
                            "storageKey": null
                          },
                          {
                            "alias": "headshots",
                            "args": (v5/*:: as any*/),
                            "concreteType": "Photo",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": (v8/*:: as any*/),
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaAlbum",
                            "kind": "LinkedField",
                            "name": "galleryAlbum",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "kind": "LinkedField",
                                "name": "mediaList",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*:: as any*/)
                                        ],
                                        "type": "Photo",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*:: as any*/)
                                        ],
                                        "type": "Video",
                                        "abstractKey": null
                                      },
                                      (v10/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "isRewardsTier2",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listName",
                            "value": "SELLER_REWARDS_2"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListMember",
                        "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "kind": "LinkedField",
                        "name": "tradeAssociations",
                        "plural": true,
                        "selections": [
                          (v3/*:: as any*/),
                          (v11/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "agreementStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sellerOrderQuantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MCAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCMetricResponseTime",
                                "kind": "LinkedField",
                                "name": "responseTime",
                                "plural": false,
                                "selections": [
                                  (v12/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "summaryCopy",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "shippingAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "displayFullCityStateCountry",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "fullCountryName",
                                "value": true
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "monthsSinceStartDate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "MONTH"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "timeSinceStartDate",
                        "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDistinguished",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTiers",
                        "kind": "LinkedField",
                        "name": "sellerTiers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGoldTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPlatinumTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sellerTierDataNotFound",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "kind": "LinkedField",
                                "name": "aggregatedFeedback",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackQuestionType",
                                    "kind": "LinkedField",
                                    "name": "overallExperience",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mean",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicNoteTotalResults",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v13/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "kind": "LinkedField",
                        "name": "sellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Phone",
                        "kind": "LinkedField",
                        "name": "trackedPhone",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelrySeller",
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v14/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v16/*:: as any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "dealerDetailsOrderFeedbackPdp",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "feedbackSellerPublicNoteHasText",
                                "value": true
                              },
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 3
                              },
                              {
                                "kind": "Literal",
                                "name": "minimumReviewRating",
                                "value": 4
                              },
                              {
                                "kind": "Literal",
                                "name": "sortBy",
                                "value": "sellerExperienceDesc"
                              }
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "completedDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Transaction",
                                        "kind": "LinkedField",
                                        "name": "transaction",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "buyer",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Profile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v4/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "kind": "LinkedField",
                                            "name": "shipment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Address",
                                                "kind": "LinkedField",
                                                "name": "shippingAddress",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayState",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayCountry",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "country",
                                                    "storageKey": null
                                                  },
                                                  (v4/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v4/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v4/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "overallExperience",
                                        "plural": false,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          (v17/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "publicNote",
                                        "plural": false,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "freetext",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      (v9/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anchorText",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v20/*:: as any*/),
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticlesType",
                            "kind": "LinkedField",
                            "name": "supplementaryEditorial",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WordpressArticleType",
                                "kind": "LinkedField",
                                "name": "articles",
                                "plural": true,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v18/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WordpressArticleImageType",
                                    "kind": "LinkedField",
                                    "name": "imageUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "full",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subtitle",
                                    "storageKey": null
                                  },
                                  (v21/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "source",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  (v18/*:: as any*/),
                  (v22/*:: as any*/),
                  (v23/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v24/*:: as any*/),
                          (v11/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": [
                      (v25/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "sitemapLinks",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v25/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v25/*:: as any*/),
                      (v7/*:: as any*/),
                      (v26/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "storyTelling",
                    "args": (v20/*:: as any*/),
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentHeader",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingModuleCreator",
                            "kind": "LinkedField",
                            "name": "contentCreatorAttribution",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creatorName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "creatorBrowseUrl",
                                "plural": false,
                                "selections": (v27/*:: as any*/),
                                "storageKey": null
                              },
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentBodyText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browseLink",
                            "plural": false,
                            "selections": (v27/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seoDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "kind": "LinkedField",
                    "name": "pdpDetailsDisplay",
                    "plural": true,
                    "selections": [
                      (v28/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "delimiter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detailDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "detailValues",
                        "plural": true,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPdpDetailValueInterface"
                          },
                          (v28/*:: as any*/),
                          (v29/*:: as any*/),
                          (v11/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayDetails",
                            "storageKey": null
                          },
                          (v30/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": [
                                  (v34/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailVersionsValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RingSizeDetail",
                                "kind": "LinkedField",
                                "name": "ringSizes",
                                "plural": true,
                                "selections": (v35/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailRingSize",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPrivateListing",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingUnlisted",
                    "storageKey": null
                  },
                  (v36/*:: as any*/),
                  {
                    "alias": "categoryL2",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "level",
                        "value": 2
                      }
                    ],
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "getCategoriesByLevel",
                    "plural": true,
                    "selections": [
                      (v37/*:: as any*/),
                      (v4/*:: as any*/)
                    ],
                    "storageKey": "getCategoriesByLevel(level:2)"
                  },
                  {
                    "alias": "dealerDetailsDisplayInfo",
                    "args": null,
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": (v38/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoVimeo",
                    "kind": "LinkedField",
                    "name": "videoVimeo",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      },
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          (v39/*:: as any*/),
                          (v40/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w100h75"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          (v39/*:: as any*/),
                          (v40/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w1280h720"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w1280h720\")"
                      },
                      (v41/*:: as any*/),
                      (v42/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "adaptive"
                          }
                        ],
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": [
                          (v21/*:: as any*/)
                        ],
                        "storageKey": "fileByVideoSize(size:\"adaptive\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoV2",
                    "kind": "LinkedField",
                    "name": "videoMux",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "playbackId",
                        "storageKey": null
                      },
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 75
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 100
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:75,width:100)"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 720
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 1280
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:720,width:1280)"
                      },
                      (v9/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assetId",
                        "storageKey": null
                      },
                      (v41/*:: as any*/),
                      (v42/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemReviewDocumentList",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemReview",
                        "kind": "LinkedField",
                        "name": "videoReview",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v43/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "kind": "LinkedField",
                    "name": "measurement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "kind": "LinkedField",
                        "name": "convertedMeasurements",
                        "plural": false,
                        "selections": [
                          (v41/*:: as any*/)
                        ],
                        "storageKey": "convertedMeasurements(unit:\"IN\")"
                      },
                      {
                        "alias": "widthDimensions",
                        "args": [
                          (v44/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v35/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"width\"])"
                      },
                      {
                        "alias": "heightDimensions",
                        "args": [
                          (v44/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v35/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"height\"])"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v45/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "firstPhotoWebPath",
                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                  },
                  (v46/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v47/*:: as any*/),
                      (v48/*:: as any*/),
                      (v4/*:: as any*/),
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v30/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "framingStatus",
                        "plural": true,
                        "selections": (v49/*:: as any*/),
                        "storageKey": null
                      },
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          (v50/*:: as any*/),
                          (v25/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "ringResizable",
                        "plural": true,
                        "selections": [
                          (v50/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hold",
                    "kind": "LinkedField",
                    "name": "activeHold",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayTimeToExpire",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v56/*:: as any*/),
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "kind": "LinkedField",
                        "name": "originalConvertedAmountList",
                        "plural": true,
                        "selections": (v33/*:: as any*/),
                        "storageKey": null
                      },
                      (v34/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "kind": "LinkedField",
                        "name": "privateOfferConvertedAmountList",
                        "plural": true,
                        "selections": (v33/*:: as any*/),
                        "storageKey": null
                      },
                      (v57/*:: as any*/),
                      (v58/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privateOfferPercentageOff",
                        "storageKey": null
                      },
                      (v59/*:: as any*/),
                      (v60/*:: as any*/),
                      (v61/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "offerExpirationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVatIncluded",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceBookName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "kind": "LinkedField",
                    "name": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "credits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "kind": "LinkedField",
                        "name": "centerPosition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "top",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "left",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "kind": "LinkedField",
                        "name": "comparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pixel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inches",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isJewelry",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": "priceType",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "buyerId",
                        "value": ""
                      },
                      (v52/*:: as any*/),
                      {
                        "kind": "Literal",
                        "name": "isTrade",
                        "value": false
                      }
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      (v59/*:: as any*/)
                    ],
                    "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "leadTimeDisplay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v29/*:: as any*/),
                      (v62/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contemporaryTrackingString",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v55/*:: as any*/),
                          (v15/*:: as any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "pdpTrackingVpvParams",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v51/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "isBuyerEstimateEnabled",
                            "value": true
                          },
                          (v53/*:: as any*/),
                          (v54/*:: as any*/),
                          (v55/*:: as any*/)
                        ],
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v65/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v65/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v65/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2UserVariant",
                        "kind": "LinkedField",
                        "name": "seoAbTestV2List",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "variant",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "testName",
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v47/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v69/*:: as any*/)
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v69/*:: as any*/)
                      }
                    ]
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v66/*:: as any*/),
                        "kind": "ScalarField",
                        "name": "hasActiveHoldForBuyer",
                        "storageKey": null
                      },
                      (v67/*:: as any*/),
                      (v68/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "categoryL3",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "level",
                                "value": 3
                              }
                            ],
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "getCategoriesByLevel",
                            "plural": true,
                            "selections": (v70/*:: as any*/),
                            "storageKey": "getCategoriesByLevel(level:3)"
                          },
                          (v71/*:: as any*/),
                          (v72/*:: as any*/),
                          (v74/*:: as any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": null,
            "args": (v76/*:: as any*/),
            "concreteType": "BuyerUrgencyInfo",
            "kind": "LinkedField",
            "name": "buyerUrgencyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalConversations",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isPopularSearchesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "alias": "suppressNewSellerSignals",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "suppressNewSellerSignals"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
          },
          {
            "alias": "videoUploadToolsFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "videoUploadTools"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"videoUploadTools\")"
          },
          {
            "alias": "vimeoItemsVideoHLSPlayerFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "vimeoItemsVideoHLSPlayer"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
          },
          {
            "alias": "sellerItems",
            "args": (v78/*:: as any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v79/*:: as any*/),
                      (v18/*:: as any*/),
                      (v46/*:: as any*/),
                      (v29/*:: as any*/),
                      (v62/*:: as any*/),
                      (v80/*:: as any*/),
                      (v72/*:: as any*/),
                      (v81/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v82/*:: as any*/),
                      (v83/*:: as any*/),
                      (v43/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v86/*:: as any*/),
                      (v36/*:: as any*/),
                      (v87/*:: as any*/),
                      (v88/*:: as any*/),
                      (v4/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v89/*:: as any*/)
                ],
                "storageKey": null
              },
              (v90/*:: as any*/),
              (v93/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sellerItems",
            "args": (v78/*:: as any*/),
            "filters": [],
            "handle": "connection",
            "key": "PdpSharedSellerItemsCarousel_sellerItems",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          {
            "alias": "favoritesPageRedesignFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "favoritesPageRedesign"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"favoritesPageRedesign\")"
          },
          {
            "alias": null,
            "args": (v95/*:: as any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v18/*:: as any*/),
                      (v29/*:: as any*/),
                      (v62/*:: as any*/),
                      (v46/*:: as any*/),
                      (v80/*:: as any*/),
                      (v72/*:: as any*/),
                      (v81/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v82/*:: as any*/),
                      (v83/*:: as any*/),
                      (v43/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v86/*:: as any*/),
                      (v36/*:: as any*/),
                      (v87/*:: as any*/),
                      (v88/*:: as any*/),
                      (v96/*:: as any*/),
                      (v4/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v89/*:: as any*/)
                ],
                "storageKey": null
              },
              (v90/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v92/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v91/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v95/*:: as any*/),
            "filters": [
              "seller",
              "itemId",
              "useML",
              "maxMLItems"
            ],
            "handle": "connection",
            "key": "PdpRespRefetchableSimilarItemsGrid_moreLikeThisItem",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          (v4/*:: as any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v16/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v19/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v31/*:: as any*/),
                      (v73/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowSellerName",
                    "storageKey": null
                  },
                  {
                    "alias": "canShowStorefrontOnlyBadge",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_STOREFRONT_ONLY_BADGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  (v4/*:: as any*/),
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": (v97/*:: as any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "childPrograms",
                                    "plural": true,
                                    "selections": (v97/*:: as any*/),
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "gdprDisplayInfo",
                "kind": "LinkedField",
                "name": "gdprDisplayInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "countryCode",
                        "variableName": "userCountryCode"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isGdprApplicable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "marketingOptInMessage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "detectFeedbackLanguage",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "detectFeedbackLanguage"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
              },
              {
                "alias": null,
                "args": (v98/*:: as any*/),
                "concreteType": "SimilarSoldItemsConnectionConnection",
                "kind": "LinkedField",
                "name": "similarSoldItemsConnection",
                "plural": false,
                "selections": [
                  (v90/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SimilarSoldItemsConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v99/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "singleItemSoldPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v29/*:: as any*/),
                              (v62/*:: as any*/),
                              (v46/*:: as any*/),
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isPdpSimilarSoldItemsModuleVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v98/*:: as any*/),
                    "concreteType": "SimilarSoldItemsConnectionConnection",
                    "kind": "LinkedField",
                    "name": "similarSoldItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "soldDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v18/*:: as any*/),
                                  (v36/*:: as any*/),
                                  (v71/*:: as any*/),
                                  (v72/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": (v56/*:: as any*/),
                                    "concreteType": "ItemDisplayPriceType",
                                    "kind": "LinkedField",
                                    "name": "displayPrice",
                                    "plural": true,
                                    "selections": (v100/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v74/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PdpDetail",
                                    "kind": "LinkedField",
                                    "name": "pdpDetailsDisplay",
                                    "plural": true,
                                    "selections": [
                                      (v28/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "detailValues",
                                        "plural": true,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          (v11/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchChat",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v1/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v14/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "shippingAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayCityStateCountry",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PresenceResults",
                            "kind": "LinkedField",
                            "name": "presence",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recentOnlineDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerPreferences",
                            "kind": "LinkedField",
                            "name": "sellerPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showOnlineStatus",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUnavailable",
                        "storageKey": null
                      },
                      (v87/*:: as any*/),
                      {
                        "alias": "buyerChatDisplayInfo",
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "kind": "LinkedField",
                        "name": "displayInfo",
                        "plural": false,
                        "selections": (v38/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "presenceFeatureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "presence"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"presence\")"
              },
              {
                "alias": "readReceiptsFeatureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "readReceipts"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"readReceipts\")"
              },
              {
                "alias": null,
                "args": (v76/*:: as any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v51/*:: as any*/),
                      (v75/*:: as any*/)
                    ],
                    "concreteType": "Conversation",
                    "kind": "LinkedField",
                    "name": "buyerItemConversation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasMessageFromSeller",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": true,
                        "selections": [
                          (v2/*:: as any*/),
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "userType",
                                "value": "BUYER"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "translatedTextBody",
                            "storageKey": "translatedTextBody(userType:\"BUYER\")"
                          },
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textBody",
                            "storageKey": null
                          },
                          (v101/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fromUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shipmentTrackingNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": (v70/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "anchors",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sourceType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                              (v2/*:: as any*/),
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionRequestedNetPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadePrivateOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadeNetPriceOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadeOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionAutomatedPrivateOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionSpecialShippingRequests",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionRequestedHold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldPlaced",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldReleased",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionShippingQuoteRequested",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCallInitiated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCustomizationOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCustomization",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionBundledOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionPrivateOfferShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionPrivateOfferHoldSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionInternalAdminJoined",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMarkedShipped",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnRequested",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnApproved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnDeclinedApproved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnCompleted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnDeclined",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionDealerCounterOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionBuyerCounterOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "kind": "LinkedField",
                            "name": "offer",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isApoFromCart",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expirationDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExpired",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSubmitted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRevisedByDealer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCountered",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "amountPerItem",
                                "plural": false,
                                "selections": (v100/*:: as any*/),
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCanceled",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "mostRecentOffer",
                                "plural": false,
                                "selections": (v13/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TransactionSummaryObject",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "offerDiscountPercentage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUnreadMessageForMember",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMember",
                        "kind": "LinkedField",
                        "name": "originalBuyer",
                        "plural": false,
                        "selections": (v13/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "transaction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "sku",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          },
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrderFeedback",
                            "kind": "LinkedField",
                            "name": "orderFeedback",
                            "plural": false,
                            "selections": [
                              (v6/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "token",
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Member",
                        "kind": "LinkedField",
                        "name": "sellerMember",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastConversationReadDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Summary",
                        "kind": "LinkedField",
                        "name": "conversationSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unread",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "conversations",
                    "args": (v102/*:: as any*/),
                    "concreteType": "ConversationsSolrConnection",
                    "kind": "LinkedField",
                    "name": "conversationsSolr",
                    "plural": false,
                    "selections": [
                      (v90/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationsSolrEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestMessage",
                                "storageKey": null
                              },
                              (v101/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inboxImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfMessages",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v18/*:: as any*/),
                                  (v3/*:: as any*/),
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "skuPhotoWebPath",
                                    "args": (v45/*:: as any*/),
                                    "kind": "ScalarField",
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestMessageReceivedAt",
                                "storageKey": null
                              },
                              {
                                "alias": "hasReplied",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isLatestMessageSender",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "originalBuyer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasUnreadTag",
                                    "storageKey": null
                                  },
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*:: as any*/),
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v89/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v93/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "conversations",
                    "args": (v102/*:: as any*/),
                    "filters": [
                      "page",
                      "buyerId"
                    ],
                    "handle": "connection",
                    "key": "BuyerChatVariant_conversations",
                    "kind": "LinkedHandle",
                    "name": "conversationsSolr"
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplayAndBtNone",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "guestId"
                  },
                  (v53/*:: as any*/),
                  (v75/*:: as any*/),
                  {
                    "kind": "Variable",
                    "name": "maxItems",
                    "variableName": "maxSponsoredItems"
                  },
                  {
                    "kind": "Variable",
                    "name": "minItemsSteps",
                    "variableName": "minSponsoredItemsSteps"
                  },
                  {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "numOfSponsoredItems"
                  },
                  (v54/*:: as any*/),
                  (v55/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "concreteType": "SponsoredItems",
                "kind": "LinkedField",
                "name": "sponsoredItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasVectorSearchResults",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAttributeResults",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SponsoredItemsMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": true,
                    "selections": [
                      (v99/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "impressionTrackerLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clickTrackerLink",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v3/*:: as any*/),
                      (v79/*:: as any*/),
                      (v18/*:: as any*/),
                      (v46/*:: as any*/),
                      (v29/*:: as any*/),
                      (v62/*:: as any*/),
                      (v80/*:: as any*/),
                      (v72/*:: as any*/),
                      (v81/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v82/*:: as any*/),
                      (v83/*:: as any*/),
                      (v43/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v86/*:: as any*/),
                      (v36/*:: as any*/),
                      (v87/*:: as any*/),
                      (v88/*:: as any*/),
                      (v4/*:: as any*/),
                      (v96/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/571.0.0-2026-08-04T16:01:33.074Z/PdpRespUnavailableLayoutRefetchQuery",
    "metadata": {},
    "name": "PdpRespUnavailableLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0743eab4d1e5c4011b289ba44aeb1472";

export default node;
